import { render, staticRenderFns } from "./otoldOrder.vue?vue&type=template&id=e3132bfa&scoped=true&"
import script from "./otoldOrder.vue?vue&type=script&lang=js&"
export * from "./otoldOrder.vue?vue&type=script&lang=js&"
import style0 from "./otoldOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./otoldOrder.vue?vue&type=style&index=1&id=e3132bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3132bfa",
  null
  
)

export default component.exports